import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE, SERVICE_AREAS } from "../data/site";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <div className="pt-32 pb-24 bg-[#050505] min-h-screen" data-testid="contact-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <div className="label-eyebrow mb-3">Contact USA Limo Service</div>
          <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight">
            Let's discuss your transportation.
          </h1>
          <p className="text-white/65 mt-5 leading-relaxed">
            Reach our 24/7 dispatch team, request a quote, or open a corporate account.
            We typically respond within one business hour.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-5">
            <div className="lux-card p-6 flex items-start gap-4" data-testid="contact-office">
              <Phone className="text-[#9B1B30] mt-1" size={20} />
              <div>
                <div className="label-eyebrow mb-1">Office</div>
                <a href={`tel:${SITE.phonesTel.office}`} className="text-white text-xl font-display">{SITE.phones.office}</a>
              </div>
            </div>
            <div className="lux-card p-6 flex items-start gap-4" data-testid="contact-virginia">
              <Phone className="text-[#9B1B30] mt-1" size={20} />
              <div>
                <div className="label-eyebrow mb-1">Virginia</div>
                <a href={`tel:${SITE.phonesTel.virginia}`} className="text-white text-xl font-display">{SITE.phones.virginia}</a>
              </div>
            </div>
            <div className="lux-card p-6 flex items-start gap-4" data-testid="contact-dispatch">
              <Clock className="text-[#9B1B30] mt-1" size={20} />
              <div>
                <div className="label-eyebrow mb-1">Dispatch · 24/7</div>
                <a href={`tel:${SITE.phonesTel.dispatch}`} className="text-white text-xl font-display">{SITE.phones.dispatch}</a>
              </div>
            </div>
            <div className="lux-card p-6 flex items-start gap-4" data-testid="contact-email-card">
              <Mail className="text-[#9B1B30] mt-1" size={20} />
              <div>
                <div className="label-eyebrow mb-1">Email</div>
                <a href={`mailto:${SITE.email}`} className="text-white text-lg">{SITE.email}</a>
              </div>
            </div>
            <div className="lux-card p-6 flex items-start gap-4" data-testid="contact-areas">
              <MapPin className="text-[#9B1B30] mt-1" size={20} />
              <div>
                <div className="label-eyebrow mb-1">Service Areas</div>
                <div className="text-white/75 text-sm leading-relaxed">{SERVICE_AREAS.join(" · ")}</div>
              </div>
            </div>
            <div className="lux-card overflow-hidden h-72">
              <iframe
                title="USA Limo Service Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d99209.1!2d-77.0!3d38.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sWashington%20DC!5e0!3m2!1sen!2sus!4v1709200000000"
                width="100%" height="100%" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
          <div className="lg:col-span-7"><ContactForm /></div>
        </div>
      </div>
    </div>
  );
}
